/* eslint react/prop-types: 0 */
import React from 'react';

import TextField from '@mui/material/TextField';

import { iconColorPalette } from '../../../styling/Colors';
import { mapIconListForGoogleMap } from '../../../consts/mapIconList';
import Paper from '@mui/material/Paper';

import './styles.scss';

const MapMarkerPicker = ({
  selectedMarker,
  updateMarker,
  className,
  showColor = true,
  showIcon = true,
  showName = true
}) => {
  const iconsFillColor = selectedMarker?.color || 'black';
  const iconsStyle = selectedMarker?.style || 'circle';
  const selectedMarkerIconIdx = selectedMarker?.icon || 0;
  const icons = mapIconListForGoogleMap(iconsFillColor, iconsStyle);

  const updateName = (name) => {
    updateMarker({ name });
  };

  const updateColor = (color) => {
    updateMarker({ color });
  };

  const updateIcon = (iconIndex) => {
    updateMarker({ icon: iconIndex });
  };

  return (
    <Paper className={`MapMarkerPicker-root ${className}`}>
      {showName && (
        <div className="edit-marker-name">
          <TextField
            label="Marker Name"
            id="outlined-size-small"
            defaultValue={selectedMarker?.name || ''}
            variant="outlined"
            size="small"
            onChange={(e) => {
              updateName(e.target.value);
            }}
          />
        </div>
      )}

      <div className="edit-marker-icon">
        {showColor && (
          <div className="MapMarkerPicker-colorDiv">
            {iconColorPalette.map((color) => (
              <div
                key={color}
                style={{ background: color }}
                className={
                  iconsFillColor === color
                    ? 'MapMarkerPicker-colorButton MapMarkerPicker-selectedColorButton'
                    : 'MapMarkerPicker-colorButton'
                }
                onClick={() => updateColor(color)}
              />
            ))}
          </div>
        )}

        {showIcon && (
          <div className="MapMarkerPicker-iconDiv">
            {icons.map((icon, index) => (
              <div
                key={index}
                className="MapMarkerPicker-iconButton"
                onClick={() => updateIcon(index)}
              >
                <img
                  src={icon}
                  alt=""
                  className={
                    selectedMarkerIconIdx === index
                      ? 'MapMarkerPicker-selectedIconButton'
                      : ''
                  }
                />
              </div>
            ))}
          </div>
        )}
      </div>
    </Paper>
  );
};

export default MapMarkerPicker;
